import axios from '../request/http';
import { toFormData } from '../common/descriptions'

const setup = {
    //客服信息
    customerService(params) {
        return axios.get("/hemei-admin/accountManage/getCustomer", { params });
    },
    // 删除客服信息
    delCustomer(params) {
        return axios.delete("/hemei-admin/accountManage/delCustomer", { params });
    },
    // 新增/修改客服信息
    accountManageAdd(data) {
        return axios.post("/hemei-admin/accountManage/add", data);
    },
    // 菜单栏
    menuBar(params) {
        return axios.get("/hemei-admin/menu/getMenuList", { params });
    },
    // 新增修改菜单栏
    routeList(data) {
        return axios.post("/hemei-admin/menu/addOrUpdMenu", data);
    },
    // 删除菜单栏
    routeUpdMenuStatus(data) {
        return axios.post("/hemei-admin/menu/updMenuStatus", toFormData(data));
    },
    // 更改菜单状态
    routeDel(params) {
        return axios.delete("/hemei-admin/menu/delMenu", { params });
    },
    // 获取角色列表getBelong
    role(params) {
        return axios.get("/hemei-admin/role/getRoleList", { params });
    },
    // 新增或修改角色
    modifyrole(data) {
        return axios.post("/hemei-admin/role/saveOrUpdateRole", data);
    },
    // 角色状态更改
    changeRoleS(data) {
        return axios.post("/hemei-admin/role/changeRoleStatus", toFormData(data));
    },
    // 删除角色
    DelRole(params) {
        return axios.delete("/hemei-admin/role/delRole", { params });
    },
    // 乡村电商管理员列表
    countMan(params) {
        return axios.get("/hemei-admin/accountManage/villageManage/accountList", { params });
    },
    // 电商管理账号新增/编辑
    addManageAccount(data) {
        return axios.post("/hemei-admin/accountManage/village/addManageAccount", data);
    },
    // 乡村电商管理员移除
    updateAccount(params) {
        return axios.get("/hemei-admin/accountManage/village/updateAccount", { params });
    },
    // 获取后台账号列表信息
    getAdminPage(params) {
        return axios.get("/hemei-admin/admin/getAdminPage", { params });
    },
    // 新增或修改 账号
    saveOrUpdateAdminInfo(data) {
        return axios.post("/hemei-admin/admin/saveOrUpdateAdminInfo", data);
    },
    //账号修改密码
    updPassword(data) {
        return axios.post("/hemei-admin/admin/updPassword", toFormData(data));
    },
    // 删除账号
    delAdminInfo(params) {
        return axios.delete("/hemei-admin/admin/delAdminInfo", { params });
    },
    // 管理员订单收入列表
    income(params) {
        return axios.get("/hemei-admin/accountManage/getAccount/income", { params });
    },
    // 管理员结算记录列表
    settlement(params) {
        return axios.get("/hemei-admin/accountManage/getAccount/settlement", { params });
    },
    // 管理员结算总合
    settlementSum(params) {
        return axios.get("/hemei-admin/accountManage/account/settlementSum", { params });
    },
    // 更改账号状态
    changeAdminInfoStatus(data) {
        return axios.post("/hemei-admin/admin/changeAdminInfoStatus", toFormData(data));
    },
    // 管理员操作日志
    logS(params) {
        return axios.get("/hemei-admin/dashboard/sysoper/log", { params });
    },
    // 乡村电商分销设置
    updateCommissionProportion(params) {
        return axios.get("/hemei-admin/ecommerceDistribution/updateCommissionProportion", { params });

    },
    // 获取乡村电商分销信息
    getCommissionProportion() {
        return axios.get("/hemei-admin/ecommerceDistribution/getCommissionProportion",);

    },
    // 标签状态编辑
    labelDel(data) {
        return axios.post("/hemei-admin/category/labelDel", toFormData(data));

    },
    // 管理员绑定用户
    bindUser(params) {
        return axios.get("/hemei-admin/login/bindUser", { params });
    },
    // 删除电话本
    delPhoneBook(params) {
        return axios.delete("/hemei-admin/phoneBook/delPhoneBook", { params });
    },
    // 订单流水
    orderFlow(params) {
        return axios.get("/hemei-admin/finance/EC/orderFlow", { params });
    },
    // 提现审核列表
    withdrawalList(params) {
        return axios.get("/hemei-admin/finance/withdrawalList", { params });
    },
    // 提现通过
    financeAccept(data) {
        return axios.post("/hemei-admin/finance/accept", toFormData(data));
    },
    // 提现拒绝
    financeReject(data) {
        return axios.post("/hemei-admin/finance/reject", toFormData(data));
    },
    // 导出流水账单
    orderFlowExport(params) {
        return axios.get("/hemei-admin/finance/EC/orderFlowExport", { params, responseType: 'arraybuffer' });
    },
    // 获取当前用户权限信息
    getRuleInfo(params) {
        return axios.get("/hemei-admin/admin/getRuleInfo", { params });
    },
    // 管理员绑定用户
    bindUser(params) {
        return axios.get("/hemei-admin/login/bindUser", {
            headers: {
                ...params,
            },
        },);
    },
    // 用户登录

    loginUser(params) {
        return axios.post("/service-user/passport/doPhoneLogin", params);
    },
    // 用户获得短信验证码
    passportgetSMSCode(params) {
        return axios.get("/service-user/passport/getSMSCode", { params });
    },
    // 话题删除
    deletes(params) {
        return axios.get("/service-article/topic/delete", { params });
    },
    // 【乡村管理员】列表
    getVillageManagePage(params) {
        return axios.get("/hemei-admin/villageInfo/getVillageManagePage", { params });
    },
    // 删除乡村管理员
    delVillageManage(data) {
        return axios.post("/hemei-admin/villageInfo/delVillageManage", toFormData(data));
    },
    // 编辑乡村管理员
    updVillageManage(data) {
        return axios.post("/hemei-admin/villageInfo/updVillageManage", data);
    },
    // 【乡村管理员】列表(新)
    newGetVillageManagePage(params) {
        return axios.get("/hemei-admin/villageInfo/getVillageManagePage/new", { params });
    },
    // 获取绑定用户信息
    getBindUserInfo(params) {
        return axios.get("/hemei-admin/login/bindUser/getBindUserInfo", { params });
    },
    // // 【乡村管理员】列表(新)
    // newGetVillageManagePage(params) {
    //     return axios.get("/hemei-admin/getVillageManagePage/new", { params });
    // }
}

export default setup;


// WEBPACK FOOTER //
// ./src/api/setup.js